<template>
  <div class="body">
    <div class="title">
      查看详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>通讯录管理</el-breadcrumb-item>
          <el-breadcrumb-item  :to="{ path: '/huiyuanziliaoshenhe' }">资料审核</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div>
      <el-tabs v-model="activeName" >
        <el-tab-pane label="基本信息" name="first">
          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <div class="fromdsadas">
                <div class="tiile">
                  基本信息
                </div>
                <div>
                  <el-form class="demo-form-inline" :label-position="labelPosition" >
                    <el-form-item label="姓名" label-width="116px">
                      {{mingpianxiangqing.realname}}
                    </el-form-item>
                    <el-form-item label="头像" label-width="116px">
                      <img :src="mingpianxiangqing.user_facepic" alt="" class="imgscc">
                    </el-form-item>
                    <el-form-item label="性别" label-width="116px">
                      {{mingpianxiangqing.usersex === 1?'男':'女'}}
                    </el-form-item>
                    <el-form-item label="手机号码" label-width="116px">
                      {{mingpianxiangqing.card_mobile}}
                    </el-form-item>
                    <el-form-item label="微信号" label-width="116px">
                      {{mingpianxiangqing.wx_user}}
                    </el-form-item>
                    <el-form-item label="家乡" label-width="116px">
                      {{mingpianxiangqing.com_provincename}}{{mingpianxiangqing.com_cityname}}{{mingpianxiangqing.com_areaname}}
                    </el-form-item>
                    <el-form-item label="是否单身" label-width="116px">
                      {{mingpianxiangqing.is_single === 0?'非单身':'单身'}}
                    </el-form-item>
                    <el-form-item label="社会职务 " label-width="116px">
                      {{mingpianxiangqing.com_identity}}
                    </el-form-item>
                  </el-form>
                </div>
                <div class="rou">
                  <!--              v-if="Query.verify_status === 0"-->
                  <button  @click="tongguoshenqing()" icon="el-icon-delete" class="tongguoscscscs" >
                    <i class="el-icon-check"></i>
                    通过申请</button>
                  <button  @click="Pushjujue()" icon="el-icon-delete" class="jujueccscscs">
                    <i class="el-icon-close mb"></i>
                    拒绝申请</button>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="fromdsadas">
                <div class="tiile">
                  审核信息
                </div>
                <el-form class="demo-form-inline" :label-position="labelPosition">
                  <el-form-item label="创建时间 " label-width="116px">
                    {{mingpianxiangqing.com_identity}}
                  </el-form-item>
                  <el-form-item label="审核状态" label-width="116px" >
                    <span :style="{'color': (mingpianxiangqing.verify_status === 0 ? '#F7D05C':mingpianxiangqing.verify_status === 1 ? '#1BB745':'#E54848')}">
                                  {{mingpianxiangqing.verify_status===0?'未审核':mingpianxiangqing.verify_status===1?'已审核':'拒绝'}}
                    </span>
                  </el-form-item>
                  <el-form-item label="审核时间 " label-width="116px">
                    {{mingpianxiangqing.status_time}}
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="生意信息" name="second">
          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <div class="fromdsadas">
                <div class="tiile">
                  基本信息
                </div>
                <div>
                  <el-form class="demo-form-inline" :label-position="labelPosition" >
                    <el-form-item label="企业名称" label-width="116px">
                      {{mingpianxiangqing.com_name}}
                    </el-form-item>
                    <el-form-item label="企业地址" label-width="116px">
                      {{mingpianxiangqing.com_cityname}}{{mingpianxiangqing.com_areaname}}{{mingpianxiangqing.com_address}}
                    </el-form-item>
                    <el-form-item label="企业所属行业" label-width="116px">
                      {{mingpianxiangqing.com_industryname}}
                    </el-form-item>
                    <el-form-item label="身份" label-width="116px">
                      {{mingpianxiangqing.com_identity}}
                    </el-form-item>
                    <el-form-item label="公司宣传图片" label-width="116px">
                      <div class="fxrowccsaa">
                        <div  v-for="(item,index) in mingpianxiangqing.com_pics" :key="index" class="imgsccccss">
                          <img :src="item.name" alt="" class="imgscc33">
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="营业执照" label-width="116px">
                      <div class="fxrowccsaa">
                        <div class="imgsccccss">
                          <img :src="mingpianxiangqing.com_license" alt="" style="min-width: 200px;height: 100px">
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="公司宣传商品" label-width="116px">
                      <videoPlayer class="video-player vjs-custom-skin"
                                   ref="videoPlayer"
                                   :playsinline="true"
                                   :options="playerOptions">
                      </videoPlayer>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="rou">
                  <!--              v-if="Query.verify_status === 0"-->
                  <button  @click="tongguoshenqing()" icon="el-icon-delete" class="tongguoscscscs" >
                    <i class="el-icon-check"></i>
                    通过申请</button>
                  <button  @click="Pushjujue()" icon="el-icon-delete" class="jujueccscscs">
                    <i class="el-icon-close mb"></i>
                    拒绝申请</button>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="供应信息" name="third">
          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <div class="fromdsadas">
                <div>
                  <el-form class="demo-form-inline" :label-position="labelPosition" >
                    <el-form-item label="供需标题" label-width="116px">
                      {{mingpianxiangqing.supply_name}}
                    </el-form-item>
                    <el-form-item label="供需介绍" label-width="116px">
                      <div class="terea">
                        {{mingpianxiangqing.supply_remark}}
                      </div>
                    </el-form-item>
                    <el-form-item label="供需图片" label-width="116px">
                      <div class="fxrowccsaa">
                        <div  v-for="(item,index) in mingpianxiangqing.supply_pics" :key="index" class="imgsccccss">
                          <img :src="item.name" alt="" class="imgscc33">
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="116px">
                      {{mingpianxiangqing.supply_mobile}}
                    </el-form-item>
                    <el-form-item label="发布时间" label-width="116px">
                      {{mingpianxiangqing.supply_time}}
                    </el-form-item>
                  </el-form>
                </div>
                <div class="rou">
                  <!--              v-if="Query.verify_status === 0"-->
                  <button  @click="tongguoshenqing()" icon="el-icon-delete" class="tongguoscscscs" >
                    <i class="el-icon-check"></i>
                    通过申请</button>
                  <button  @click="Pushjujue()" icon="el-icon-delete" class="jujueccscscs">
                    <i class="el-icon-close mb"></i>
                    拒绝申请</button>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="需求信息" name="four">
          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <div class="fromdsadas">
                <div>
                  <el-form class="demo-form-inline" :label-position="labelPosition" >
                    <el-form-item label="供需标题" label-width="116px">
                      {{mingpianxiangqing.need_name}}
                    </el-form-item>
                    <el-form-item label="供需介绍" label-width="116px">
                      <div class="terea">
                        {{mingpianxiangqing.need_remark}}
                      </div>
                    </el-form-item>
                    <el-form-item label="供需图片" label-width="116px">
                      <div class="fxrowccsaa">
                        <div  v-for="(item,index) in mingpianxiangqing.need_pics" :key="index" class="imgsccccss">
                          <img :src="item.name" alt="" class="imgscc33">
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="116px">
                      {{mingpianxiangqing.need_mobile}}
                    </el-form-item>
                    <el-form-item label="发布时间" label-width="116px">
                      {{mingpianxiangqing.need_time}}
                    </el-form-item>
                  </el-form>
                </div>
                <div class="rou">
                  <!--              v-if="Query.verify_status === 0"-->
                  <button  @click="tongguoshenqing()" icon="el-icon-delete" class="tongguoscscscs" >
                    <i class="el-icon-check"></i>
                    通过申请</button>
                  <button  @click="Pushjujue()" icon="el-icon-delete" class="jujueccscscs">
                    <i class="el-icon-close mb"></i>
                    拒绝申请</button>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <vxe-modal  width="336" ref="tongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClose">
        <div class="titledd">
          是否确认通过申请?
        </div>
        <div class="bobox">
          <button class="queren" @click="openqueren">
            确认
          </button>
          <button class="quxiao"  @click="routeClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal  width="336" ref="jujue" height="202" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClosecc">
        <div class="titledd mbP">
          是否确认通过申请?
        </div>
        <vxe-input v-model="remark" placeholder="请输入拒绝理由"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openjujue">
            确认
          </button>
          <button class="quxiao"  @click="routeClosecc">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cardSetverifystatus, cardview } from '@/api/tongxunlu'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  computed: {
    ...mapState(['huiyuanID'])
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    videoPlayer
    // eslint-disable-next-line vue/no-unused-components
    // eslint-disable-next-line vue/no-unused-components
  },
  name: 'huodongguanlichakanxiangqing',
  data () {
    return {
      playerOptions: {
        // 播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        // 如果true,浏览器准备好时开始回放。
        autoplay: true,
        // 默认情况下将会消除任何音频。
        muted: true,
        // 导致视频一结束就重新开始。
        loop: true,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        height: 200, // document.documentElement.clientHeight 播放器高度
        sources: [{
          // 类型
          type: 'video/mp4',
          // url地址
          src: 'http://mp4.taoxiangou.net/%E9%A6%96%E4%B8%AA.mp4'
        }],
        // 你的封面地址
        poster: '',
        // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          // 全屏按钮
          fullscreenToggle: false
        }
      },
      labelPosition: 'left',
      activeName: 'first',
      mingpianxiangqing: {},
      remark: ''
    }
  },
  created () {
    this.list()
  },
  methods: {
    openjujue () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.this.huiyuanID,
        apply_type: 2,
        apply_remark: this.remark
      }
      cardSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.jujue.close()
          this.list()
        }
      })
    },
    openqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.huiyuanID,
        apply_type: 1
      }
      cardSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.tongguo.close()
          this.list()
        }
      })
    },
    tongguoshenqing () {
      this.$refs.tongguo.open()
    },
    routeClose () {
      this.$refs.tongguo.close()
    },
    Pushjujue () {
      this.$refs.jujue.open()
    },
    routeClosecc () {
      this.$refs.jujue.close()
    },
    list () {
      const obj = {
        token: sessionStorage.getItem('token'),
        card_id: this.huiyuanID
      }
      cardview(obj).then(({ data: res }) => {
        console.log('res', res)
        this.mingpianxiangqing = res
        this.playerOptions.sources[0].src = res.com_video
      })
    }
  }

}
</script>

<style  lang="less" >
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.terea{
  width: 550px;
}
.fxrowccsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 400px;
  .imgsccccss{
    width: 100px;
    height: 100px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: inline-block;
    .imgscc33{
      width: 100%;
      height: 100%;
    }
  }
}
.imgscc{
  width: 100px;
  height: 100px;
}
.rou{
  display:flex;
  flex-direction: row;
}
.tongguoscscscs{
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#1bb745, #17ab3f);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border: none;
}
.mb{
  margin-right: 10px;
}
.jujueccscscs{
  border: none;
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg,#e54848, #d54141);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.fromdsadas{
  display:flex;
  flex-direction: column;
  .tiile{
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 42px;
  }
}
.ml{
  margin-left: 10px;
}
.addzanzu{
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #3d9aff;
}
.from{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.imgbox{
  width: 188px;
  height: 188px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 5px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  .imgs{
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}
.radiobox {
  display: flex;
  flex-direction: row;
  align-items: center;

  .samnfa {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 10px;

    .imgs {
      width: 20px;
      height: 20px;
      opacity: 1;
      margin-right: 20px;
    }
  }
}
.el-upload-list{
  display: none;
}
.el-scrollbar__wrap{
  height: 200px ;
}
.dsadf{
  color: #3D9AFF;
}
.hearder{
  //width: 500px;
  display:flex;
  flex-direction: row;
  align-items: center;
  .left{
    flex:1
  }
}
.boxssdff{
  display:flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 11px;
  .addss{
    flex: 1;
  }
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
  }
  .fromsss{
    margin-top: 54px;
  }
}
</style>
